<template>
  <Dialog
    ref="availabilityNoteRef"
    dialog-mode="medium"
    content-class="dialog-content"
    header-class="gap-2 flex !pr-[40px] !justify-start align-center"
    class="availability-dialog"
  >
    <template #title>
      <span class="text-lg font-bold">{{
        t("shared.product.availability.in_stock_overseas_dialog_title", [availabilityNoteProduct?.code ?? ""])
      }}</span>
    </template>
    <template #content>
      <ProductFormContact
        :subtitle="t('shared.product.availability.in_stock_overseas_note', [availabilityNoteProduct?.code ?? ''])"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { eventBus } from "@/shared/thorlabs/shared";
import type { Product, VariationTypeExtension } from "@/core/api/graphql/types";
import ProductFormContact from "@/shared/catalog/components/product/product-form-contact.vue";
import Dialog from "@/shared/thorlabs/shared/components/dialog-modal.vue";

const { t } = useI18n();
const availabilityNoteProduct = ref<Product | VariationTypeExtension | null>(null);
const availabilityNoteRef = ref<InstanceType<typeof Dialog> | null>(null);

eventBus.on("showAvailabilityNoteDialog", (payload) => {
  availabilityNoteProduct.value = { ...payload.product };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  availabilityNoteRef.value?.openDialog();
});

onUnmounted(() => {
  eventBus.off("showAvailabilityNoteDialog");
});
</script>
